// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { ECandidatesSelectionPolicy, EInvalidVotePolicy, EOverVotePolicy, } from "@sequentech/ui-core";
var UNSELECTED = -1;
export var isSelected = function (choice) { return choice.selected > UNSELECTED; };
/** Choosing a candidate replaces the current one instead of adding to it. */
export var replacesOnSelect = function (contest) {
    var _a;
    return contest.max_votes === 1 &&
        ((_a = contest.presentation) === null || _a === void 0 ? void 0 : _a.candidates_selection_policy) === ECandidatesSelectionPolicy.RADIO;
};
/** A selection above the maximum is refused, not recorded and reported. */
export var refusesOverVotes = function (contest) { var _a; return ((_a = contest.presentation) === null || _a === void 0 ? void 0 : _a.over_vote_policy) === EOverVotePolicy.NOT_ALLOWED_WITH_MSG_AND_DISABLE; };
/**
 * How many of the contest's choices are taken, counted as the ballot codec
 * counts them: the explicit blank option is not a choice, and an explicit
 * invalid mark is one unless selecting a candidate clears it.
 */
export var countSelections = function (contest, selection) {
    var _a;
    var blankIds = new Set(contest.candidates
        .filter(function (candidate) { var _a; return (_a = candidate.presentation) === null || _a === void 0 ? void 0 : _a.is_explicit_blank; })
        .map(function (candidate) { return candidate.id; }));
    var candidates = selection.choices.filter(function (choice) { return isSelected(choice) && !blankIds.has(choice.id); }).length;
    var countsInvalidMark = selection.is_explicit_invalid &&
        ((_a = contest.presentation) === null || _a === void 0 ? void 0 : _a.invalid_vote_policy) !==
            EInvalidVotePolicy.ALLOWED_WITH_EXCLUSIVE_EXPLICIT;
    return candidates + (countsInvalidMark ? 1 : 0);
};
export var exceedsMaximum = function (contest, selections) {
    return selections > contest.max_votes;
};
